import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { showDialog } from "@widgets/CommonDialog";
import { fnSave } from "@shared/api/restApi";
import { global } from "@shared/libs/Global";
import IconButton from "@mui/material/IconButton";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";

interface PasswordPopupProps {
  cd_user?: any;
  modalRef?: any;
}

const ResetPwdPopup = forwardRef(
  ({ cd_user, modalRef }: PasswordPopupProps, ref) => {
    const { userInfo } = global();

    const passwordRef = useRef<HTMLInputElement>(null);
    const confirmRef = useRef<HTMLInputElement>(null);

    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [showPwd, setShowPwd] = useState(false);
    const [showConfirmPwd, setShowConfirmPwd] = useState(false);

    useEffect(() => {
      passwordRef.current?.focus();
    }, []);

    useImperativeHandle(ref, () => ({
      getSelectedValue: async () => {
        if (!password || !confirm) {
          return { code: "POPUP_PASSWORD", data: "empty" };
        }
        if (password !== confirm) {
          return { code: "POPUP_PASSWORD", data: "notConfirm" };
        }
        const result = await onSave();
        if (result) {
          return { code: "POPUP_PASSWORD", data: password };
        } else {
          return { code: "POPUP_PASSWORD", data: "error" };
        }
      },
      focusToErrorInput: () => {
        // if (!password || !confirm) {
        //   passwordRef.current?.focus();
        // } else if (password !== confirm) {
        //   confirmRef.current?.focus();
        // }
        passwordRef.current?.focus();
      },
    }));

    const handleKeyDown = (
      e: React.KeyboardEvent<HTMLInputElement>,
      current: "password" | "confirm"
    ) => {
      if (e.key === "Enter" || e.key === "Tab") {
        e.preventDefault();

        if (current === "password") {
          confirmRef.current?.focus();
        } else {
          modalRef?.current?.handleConfirm(true);
        }
      }
    };

    const onSave = async () => {
      try {
        const changedData = {
          cd_firm: userInfo.cd_firm,
          cd_user: cd_user,
          no_pwd: password,
        };

        const SaveData = {
          sys_user: { update: [changedData] },
        };
        return await fnSave("SN_SYS_AUT_REG_004_SAVE_01", SaveData);
      } catch (error: any) {
        await showDialog(
          "error",
          "비밀번호 변경에 실패했습니다. 관리자에게 문의해주세요."
        );
        return false;
      }
    };

    return (
      <div className="w-full">
        <div className="mb-3">
          <label className="block text-sm mb-1">비밀번호</label>
          <div style={{ position: "relative" }}>
            <input
              ref={passwordRef}
              type={showPwd ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, "password")}
              className="w-full border px-2 py-1 pr-10 rounded"
              style={{ borderColor: "rgb(196 196 196)" }}
            />

            <IconButton
              size="small"
              onClick={() => setShowPwd((prev) => !prev)}
              sx={{
                position: "absolute",
                right: 8,
                top: "50%",
                transform: "translateY(-50%)",
              }}
            >
              {showPwd ? (
                <VisibilityOff fontSize="small" />
              ) : (
                <Visibility fontSize="small" />
              )}
            </IconButton>
          </div>
        </div>

        <div className="mb-3">
          <label className="block text-sm mb-1">비밀번호 확인</label>
          <div style={{ position: "relative" }}>
            <input
              ref={confirmRef}
              type={showConfirmPwd ? "text" : "password"}
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, "confirm")}
              onPaste={(e) => e.preventDefault()}
              className="w-full border px-2 py-1 pr-10 rounded"
              style={{ borderColor: "rgb(196 196 196)" }}
            />

            <IconButton
              size="small"
              onClick={() => setShowConfirmPwd((prev) => !prev)}
              sx={{
                position: "absolute",
                right: 8,
                top: "50%",
                transform: "translateY(-50%)",
              }}
            >
              {showConfirmPwd ? (
                <VisibilityOff fontSize="small" />
              ) : (
                <Visibility fontSize="small" />
              )}
            </IconButton>
          </div>
        </div>
      </div>
    );
  }
);

export default ResetPwdPopup;
